import { useQueryState } from "nuqs";
import { useCallback } from "react";

export const PRODUCT_SORTING_OPTIONS = [
	{ key: "sort.recommended", sortBy: "recommended", sortOrder: "desc" },
	{ key: "sort.popular", sortBy: "popularity", sortOrder: "desc" },
	{ key: "sort.priceLowToHigh", sortBy: "price", sortOrder: "asc" },
	{ key: "sort.priceHighToLow", sortBy: "price", sortOrder: "desc" },
	{ key: "sort.newArrivals", sortBy: "createdAt", sortOrder: "desc" },
	{ key: "sort.thcLowToHigh", sortBy: "thc", sortOrder: "asc" },
	{ key: "sort.thcHighToLow", sortBy: "thc", sortOrder: "desc" },
] as const;

type ProductSortingOption = (typeof PRODUCT_SORTING_OPTIONS)[number];
type ProductSortingOptionKey = ProductSortingOption["key"];

export function useProductSort() {
	const [sortField, setSortField] = useQueryState("sort");
	const [sortOrder, setSortOrder] = useQueryState("order");

	const sortingOptions = PRODUCT_SORTING_OPTIONS;

	const onSortChange = useCallback(
		(sortKey: ProductSortingOptionKey) => {
			const option = sortingOptions.find((o) => o.key === sortKey);

			if (!option) return;

			setSortField(option.sortBy);
			setSortOrder(option.sortOrder);
		},
		[setSortField, setSortOrder, sortingOptions],
	);

	return {
		options: sortingOptions,
		sort: sortingOptions.find(
			(so) => so.sortBy === sortField && so.sortOrder === sortOrder,
		)?.key,
		onSortChange,
	};
}
